import React from 'react'
import RemoteActionStatusBadge from './RemoteActionStatusBadge'

class UpdateList extends React.Component {

  formatTime(timestamp) {
    const d = new Date(timestamp)
    d.setHours(d.getHours() - 2)
    return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`
  }

  render() {
    const { updates } = this.props

    if (!updates || updates.length === 0) {
      return (
        <div className="ulist-empty">
          <i className="fas fa-sync-alt"></i>
          <p>No hay actualizaciones para el período seleccionado</p>
        </div>
      )
    }

    return (
      <div className="ulist-grid">
        {updates.map(update => (
          <div key={update._id} className="ulist-card">
            <div className="ulist-card-top">
              <RemoteActionStatusBadge status={update.Status} />
              <span className="ulist-time">{this.formatTime(update.TimeStamp)}</span>
            </div>
            <div className="ulist-card-body">
              <div className="ulist-field">
                <span className="ulist-label"><i className="fas fa-desktop"></i> Máquina</span>
                <span className="ulist-value">{update.Machine}</span>
              </div>
              <div className="ulist-field">
                <span className="ulist-label"><i className="fas fa-user"></i> Cliente</span>
                <span className="ulist-value">{update.Customer && update.Customer.Fullname}</span>
              </div>
              <div className="ulist-field">
                <span className="ulist-label"><i className="fas fa-box"></i> Taquilla</span>
                <span className="ulist-value ulist-matricula">{update.Matricula}</span>
              </div>
              <div className="ulist-field">
                <span className="ulist-label"><i className="fas fa-barcode"></i> SN</span>
                <span className="ulist-value">{update.Locker}</span>
              </div>
              <div className="ulist-field">
                <span className="ulist-label"><i className="fas fa-phone"></i> Teléfono</span>
                <span className="ulist-value">{update.Phone}</span>
              </div>
              {update.PDA && (
                <div className="ulist-field">
                  <span className="ulist-label"><i className="fas fa-tablet-alt"></i> PDA</span>
                  <span className="ulist-value">{update.PDA}</span>
                </div>
              )}
              {update.LockStatus && (
                <div className="ulist-field">
                  <span className="ulist-label"><i className="fas fa-lock"></i> Estado cierre</span>
                  <span className="ulist-value">{update.LockStatus}</span>
                </div>
              )}
            </div>
            <div className="ulist-card-footer">
              <span className="ulist-invoice"><i className="fas fa-file-invoice"></i> {update.Invoice || '—'}</span>
            </div>
          </div>
        ))}
      </div>
    )
  }
}

export default UpdateList

